'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface ITutorialMiniPlayerItem {
    title: string
    /** Generic URL for any video source (YouTube, mp4, HLS, etc.). */
    url: string
    posterUrl?: string
}

interface ITutorialMiniPlayerState {
    activeTutorial: ITutorialMiniPlayerItem | null
    openTutorial: (tutorial: ITutorialMiniPlayerItem) => void
    closeTutorial: () => void
}

export const useTutorialMiniPlayerZustand = create<ITutorialMiniPlayerState>()(
    devtools(
        (set) => ({
            activeTutorial: null,
            openTutorial: (tutorial) => set({ activeTutorial: tutorial }),
            closeTutorial: () => set({ activeTutorial: null }),
        }),
        { name: 'tutorial-mini-player-zustand' }
    )
)
